import axios from "axios";
import router from "./router.js";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API,
  withCredentials: true,
  timeout: 10000, // set the default timeout for requests to 5 seconds
});

// Request Interceptor
instance.interceptors.request.use(
  (config) => {
    let currency = localStorage.getItem('currency');
    if (!currency) {
        currency = 'EUR'
    }
    // const authToken = localStorage.getItem("authToken");

    // if (authToken) {
    //   config.headers["Authorization"] = `Bearer ${authToken}`;
    // }


    const excludeUrls = [""];
    if (!excludeUrls.includes(config.url)) {
      if (config.method === "get") {
        config.params = {
          ...config.params,
          currency
        };
      } else if (
        ["post", "put", "patch"].includes(config.method.toLowerCase())
      ) {
        config.data = {
          ...config.data,
          currency
        };
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response Interceptor
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) {
      return Promise.reject(
        new Error("Network error, please try again later.")
      );
    }

    const { status, config } = error.response;
    
    // Avoid redirect loops for auth endpoints and prevent multiple redirects
    if (status === 401 && 
        !config.url.includes('login') && 
        !config.url.includes('is-auth') &&
        router.currentRoute.name !== 'Login') {
      router.push({ name: 'Login' });
    } else if (status === 403) {
      router.push({ name: "EmailVerificationNotice" });
    }

    return Promise.reject(error);
  }
);

export default instance;
